import React from "react";
import { Box, TabPanel, Tabs } from '@mui/joy';
import Container from './dashboard/Container'

const Dashboard = ({ dataProviderName, filters }) => {

    return (
        <Box className="dashboard-menu dashboard-menu-1col" sx={{ marginTop: 0 }}>
            <Tabs
                orientation="horizontal"
                size="sm"
                className="dashboard-tabs"
            >
                <TabPanel value={0} className="dashboard-tab-panel">
                    <Container dataProviderName={dataProviderName} filters={filters}/>
                </TabPanel>
            </Tabs>
        </Box>
    );
}

export default Dashboard;
